export default __webpack_public_path__ + "static/media/icon-llamada.26ee9821.svg";